import { Container, Sprite, Text } from 'pixi.js';
import { DropShadowFilter } from 'pixi-filters';
import MathUtils from '../../utils/MathUtils';

export function testShadowDrop(): void {
  const root = new Container();

  root.props({
    parent: root.pixi.stage,
  });

  const amount = new Text({
    text: '0',
    style: {
      fontSize: 40,
      fill: 'white',
      stroke: { color: 'black', width: 5 },
    }
  }).props({
    parent: root,
    x: root.pixi.renderer.width * 0.5,
    y: 100,
    anchor: 0.5,
  });

  const texture = [
    'tile_blue',
    'tile_green',
    'tile_red',
    'tile_grey',
    'tile_navy',
    'tile_purple'
  ];

  setInterval(() => {
    new Sprite().props({
      parent: root,
      x: Math.random() * root.pixi.renderer.width,
      y: Math.random() * root.pixi.renderer.height,
      anchor: 0.5,
      angle: Math.random() * 360,
      texture: MathUtils.rnd.pick(texture),
    });

    const shadow = new Sprite().props({
      parent: root,
      x: Math.random() * root.pixi.renderer.width,
      y: Math.random() * root.pixi.renderer.height,
      anchor: 0.5,
      angle: Math.random() * 2,
      texture: MathUtils.rnd.pick(texture),
    });
    shadow.filters = [new DropShadowFilter()];

    amount.text = root.children.length;
  }, 2000);
}
